import TagManager from 'react-gtm-module'

/**
 * Track a custom event in Google Tag Manager
 * @param eventName - The name of the event (e.g., 'button_click', 'download_app')
 * @param eventData - Additional data to send with the event
 */
export const trackGTMEvent = (
    eventName: string,
    eventData?: Record<string, any>
) => {
    try {
        TagManager.dataLayer({
            dataLayer: {
                event: eventName,
                ...eventData,
            },
        })
    } catch (error) {
        console.error('Error tracking GTM event:', error)
    }
}

/**
 * Track button click events
 * @param buttonName - Name/identifier of the button clicked
 * @param location - Where the button is located (e.g., 'hero', 'whatis', 'tryout')
 * @param additionalData - Any additional data to track
 */
export const trackButtonClick = (
    buttonName: string,
    location: string,
    additionalData?: Record<string, any>
) => {
    trackGTMEvent('button_click', {
        button_name: buttonName,
        button_location: location,
        ...additionalData,
    })
}

